import IconAdd from '../../../assets/icons/add.svg';
import IconAddWhite from '../../../assets/icons/add-white.svg';
import IconList from '../../../assets/icons/list.svg';
import IconListWhite from '../../../assets/icons/list-white.svg';
import IconNotifications from '../../../assets/icons/notifications.svg';
import IconSettings from '../../../assets/icons/settings.svg';
import IconLogout from '../../../assets/icons/logout.svg';
import IconHelp from '../../../assets/icons/help.svg';
import IconAccount from '../../../assets/icons/user.svg';
import IconCompany from '../../../assets/icons/office.svg';
import IconRuler from '../../../assets/icons/ruler.svg';
import IconTax from '../../../assets/icons/tax.svg';
import IconLocation from '../../../assets/icons/location.svg';

import { MdShoppingCart } from "react-icons/md";
import { MdInventory } from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";
import { LuRefreshCcwDot } from "react-icons/lu";
import { MdFactory } from "react-icons/md";
import { FaShoppingBag } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaHandshakeSimple } from "react-icons/fa6";
import { HiDocumentReport } from "react-icons/hi";
import { MdOutlineInventory } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { BiSolidShoppingBag } from "react-icons/bi";

import { FaUserFriends } from "react-icons/fa";
import { BsFillBuildingFill } from "react-icons/bs";
import { HiMiniRectangleGroup } from "react-icons/hi2";
import { TbRulerMeasure } from "react-icons/tb";
import { BiSolidCalculator } from "react-icons/bi";
import { FaCodeBranch } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";

export const NAV_ITEMS = [
    {
        itemName: "Home",
        page: '/home'
    },
    {
        itemName: "Sales",
        dropDownItems: [
            {
                id: 'list_sales_orders',
                icon: MdShoppingCart,
                text: 'Sales Orders',
                modal: false,
                page: '/sales-orders'
            },
            {
                id: 'list_customers',
                icon: FaUsers,
                text: 'Customers',
                modal: false,
                page: '/customers'
            }
        ]
    },
    {
        itemName: "Stock",
        dropDownItems: [
            {
                id: 'items',
                icon: MdInventory,
                text: 'Products',
                modal: false,
                page: '/items'
            },
            {
                id: 'items',
                icon: TbTruckDelivery,
                text: 'Stock Transfers',
                modal: false,
                page: '/stock-transfers'
            },
            {
                id: 'items',
                icon: LuRefreshCcwDot,
                text: 'Stock Adjustments',
                modal: false,
                page: '/stock-adjustments'
            },
            {
                id: 'list_work_orders',
                icon: MdFactory,
                text: 'Work Orders',
                modal: false,
                page: '/work-orders'
            }
        ]
    },
    {
        itemName: "Purchasing",
        dropDownItems: [
            {
                id: 'purchase_orders',
                icon: BiSolidShoppingBag,
                text: 'Purchase Orders',
                modal: false,
                page: '/purchase-orders'
            },
            {
                id: 'list_suppliers',
                icon: FaHandshakeSimple,
                text: 'Suppliers',
                modal: false,
                page: '/suppliers'
            }
        ]
    },
    {
        itemName: "Report",
        dropDownItems: [
            {
                id: 'sales_reports',
                icon: HiDocumentReport,
                text: 'Sales Report',
                modal: false,
                page: '/sales-reports'
            },
            {
                id: 'inventory_reports',
                icon: MdOutlineInventory,
                text: 'Stock Report',
                modal: false,
                page: '/inventory-reports'
            },
            {
                id: 'purchase_reports',
                icon: TbReportAnalytics,
                text: 'Purchasing Report',
                modal: false,
                page: '/purchase-reports'
            },
           
        ]
    },
]

export const SETTING_NOTFICATION_BAR = [
    {
        itemName: "Settings",
        icon: IconSettings,
        dropDownItems: [
            {
                id: 'accounts',
                icon: FaUserFriends,
                text: 'Accounts',
                modal: false,
                page: '/accounts'
            },
            {
                id: 'company',
                icon: BsFillBuildingFill,
                text: 'Comapny',
                modal: false,
                page: '/company'
            },
            {
                id: 'item_groups',
                icon: HiMiniRectangleGroup,
                text: 'Categories',
                modal: false,
                page: '/item-groups'
            },
            {
                id: 'list_unit_measures',
                icon: TbRulerMeasure,
                text: 'Unit of Measures',
                modal: false,
                page: '/unit-of-measures'
            },
            {
                id: 'list_item_taxes',
                icon: BiSolidCalculator,
                text: 'Item Taxes',
                modal: false,
                page: '/item-taxes'
            },
            {
                id: 'list_location',
                icon: FaCodeBranch,
                text: 'Branches',
                modal: false,
                page: '/locations'
            },
            {
                id: 'logout',
                icon: FaSignOutAlt,
                text: 'logout',
                modal: false,
                page: '/logout',
                breakpoint: true,
                inverted: true
            },
        ]
    },
]



